/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendProjectConfigDto } from '../models/backend-project-config-dto';
import { projectsEnumChoicesRetrieve } from '../fn/projects-config/projects-enum-choices-retrieve';
import { ProjectsEnumChoicesRetrieve$Params } from '../fn/projects-config/projects-enum-choices-retrieve';
import { projectsProjectConfigPartialUpdate } from '../fn/projects-config/projects-project-config-partial-update';
import { projectsProjectConfigPartialUpdate$FormData } from '../fn/projects-config/projects-project-config-partial-update-form-data';
import { ProjectsProjectConfigPartialUpdate$FormData$Params } from '../fn/projects-config/projects-project-config-partial-update-form-data';
import { ProjectsProjectConfigPartialUpdate$Params } from '../fn/projects-config/projects-project-config-partial-update';
import { projectsProjectConfigPartialUpdate$XWwwFormUrlencoded } from '../fn/projects-config/projects-project-config-partial-update-x-www-form-urlencoded';
import { ProjectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-config/projects-project-config-partial-update-x-www-form-urlencoded';
import { projectsProjectConfigRetrieve } from '../fn/projects-config/projects-project-config-retrieve';
import { ProjectsProjectConfigRetrieve$Params } from '../fn/projects-config/projects-project-config-retrieve';
import { projectsProjectConfigUpdate } from '../fn/projects-config/projects-project-config-update';
import { projectsProjectConfigUpdate$FormData } from '../fn/projects-config/projects-project-config-update-form-data';
import { ProjectsProjectConfigUpdate$FormData$Params } from '../fn/projects-config/projects-project-config-update-form-data';
import { ProjectsProjectConfigUpdate$Params } from '../fn/projects-config/projects-project-config-update';
import { projectsProjectConfigUpdate$XWwwFormUrlencoded } from '../fn/projects-config/projects-project-config-update-x-www-form-urlencoded';
import { ProjectsProjectConfigUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-config/projects-project-config-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsEnumChoicesRetrieve()` */
  static readonly ProjectsEnumChoicesRetrievePath = '/api/projects/enum-choices/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsEnumChoicesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsEnumChoicesRetrieve$Response(
    params?: ProjectsEnumChoicesRetrieve$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      [key: string]: any;
    }>
  > {
    return projectsEnumChoicesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsEnumChoicesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsEnumChoicesRetrieve(
    params?: ProjectsEnumChoicesRetrieve$Params,
    context?: HttpContext,
  ): Observable<{
    [key: string]: any;
  }> {
    return this.projectsEnumChoicesRetrieve$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            [key: string]: any;
          }>,
        ): {
          [key: string]: any;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectsProjectConfigRetrieve()` */
  static readonly ProjectsProjectConfigRetrievePath = '/api/projects/project-config/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectConfigRetrieve$Response(
    params: ProjectsProjectConfigRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectConfigRetrieve(
    params: ProjectsProjectConfigRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectConfigUpdate()` */
  static readonly ProjectsProjectConfigUpdatePath = '/api/projects/project-config/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectConfigUpdate$Response(
    params: ProjectsProjectConfigUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectConfigUpdate(
    params: ProjectsProjectConfigUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectConfigUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectConfigUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectConfigUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectConfigUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectConfigUpdate$FormData$Response(
    params: ProjectsProjectConfigUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectConfigUpdate$FormData(
    params: ProjectsProjectConfigUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectConfigPartialUpdate()` */
  static readonly ProjectsProjectConfigPartialUpdatePath = '/api/projects/project-config/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectConfigPartialUpdate$Response(
    params: ProjectsProjectConfigPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectConfigPartialUpdate(
    params: ProjectsProjectConfigPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectConfigPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectConfigPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectConfigPartialUpdate$FormData$Response(
    params: ProjectsProjectConfigPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
    return projectsProjectConfigPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectConfigPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectConfigPartialUpdate$FormData(
    params: ProjectsProjectConfigPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectConfigDto> {
    return this.projectsProjectConfigPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectConfigDto>): BackendProjectConfigDto => r.body),
    );
  }
}
